/**
 * The admin action log.
 *
 * Includes failed logins, because a run of those is the single most useful
 * signal this console produces about itself.
 */
import { useQuery } from '@tanstack/react-query'

import { api, type AuditEntry } from '../lib/api'
import { Empty, Loading, Panel, dateTime } from '../components/ui'

const TONE: Record<string, string> = {
  login_failed: 'var(--color-down)',
  login: 'var(--color-faint)',
  approve_withdrawal: 'var(--color-info)',
  reject_withdrawal: 'var(--color-warn)',
  attribute_deposit: 'var(--color-up)',
}

export function AuditPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['audit'],
    queryFn: () => api.get<{ entries: AuditEntry[] }>('/audit?limit=200'),
  })

  return (
    <Panel title="Admin activity">
      {isLoading ? (
        <Loading />
      ) : !data || data.entries.length === 0 ? (
        <Empty>Nothing recorded yet.</Empty>
      ) : (
        <div className="overflow-x-auto">
          <table className="grid-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Action</th>
                <th>Subject</th>
                <th>Detail</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {data.entries.map((e) => (
                <tr key={e.id}>
                  <td className="tnum whitespace-nowrap" style={{ color: 'var(--color-muted)' }}>
                    {dateTime(e.createdAt)}
                  </td>
                  <td className="font-semibold" style={{ color: TONE[e.action] ?? 'var(--color-text)' }}>
                    {e.action}
                  </td>
                  <td className="hash">{e.subject ?? '—'}</td>
                  <td className="hash max-w-[420px] truncate">{e.detail ?? '—'}</td>
                  <td className="hash">{e.ip ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  )
}
